import { render, staticRenderFns } from "./adminGuilds.vue?vue&type=template&id=33b390ac&scoped=true&"
import script from "./adminGuilds.vue?vue&type=script&lang=js&"
export * from "./adminGuilds.vue?vue&type=script&lang=js&"
import style0 from "./adminGuilds.vue?vue&type=style&index=0&id=33b390ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b390ac",
  null
  
)

export default component.exports